import Vue from 'vue';

Vue.component('gdpr', () => import(/* webpackChunkName: "gdpr" */ './gdpr'));
